// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"288":"b03d6115aaf85ba8b428","830":"11ccc4a21def6152820c"}[chunkId] + ".min.js";
};